<template>

    <div class="news-top" v-if="type == 'top'" @click="$router.push(refererLink)">
        <div class="news-top-back">
            <h3 v-text="theNew.kicker"></h3>
            <router-link :to="refererLink" v-text="theNew.main_headline"></router-link>
        </div>
        <img :src="`${VUE_APP_SERVER_ROOT}picture/${theNew.pictures.main}`" alt="">
    </div>

    <div :class="(meshkati ? 'meshkati' : 'news') + '-post-1'" v-else-if="type == 'post-1'" @click="$router.push(refererLink)">
        <img :src="`${VUE_APP_SERVER_ROOT}picture/${theNew.pictures.main}`" alt="">
        <h4 v-text="localeDatetime"></h4>
        <h3 v-text="theNew.kicker"></h3>
        <h2 v-text="theNew.main_headline"></h2>
    </div>

    <div class="am-pj-post" v-else-if="type == 'am-pj'" @click="$router.push(refererLink)">
        <img :src="`${VUE_APP_SERVER_ROOT}picture/${theNew.pictures.main}`" alt="">
        <h3 v-text="theNew.kicker"></h3>
        <h2 v-text="theNew.main_headline"></h2>
    </div>

    <div class="news-post-2" v-else-if="type == 'post-2'" @click="$router.push(refererLink)">

    </div>

</template>

<script setup>
import { ref, defineProps, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const props = defineProps({ type: String, theNew: Object, meshkati: Boolean, school: String })
    , $router = useRouter()
    , $route = useRoute()
    , { locale, t } = useI18n()
    , refererLink = computed(() => `${$route.params.locale ? `/${$route.params.locale}` : ''}${props.school ? `/${props.school}` : ''}/visit/${props.theNew.id}/${props.theNew.main_headline.replaceAll(/\w/g, '-')}`)
    , localeDatetime = computed(() => t('timeString', { time: (new Date(props.theNew.created_datetime)).toLocaleTimeString(t('timeLocale')).match(/^..?:..?/g)[0], date: (new Date(props.theNew.created_datetime)).toLocaleDateString(t('timeLocale')) }))
    , VUE_APP_SERVER_ROOT = process.env.VUE_APP_SERVER_ROOT

</script>